<template>
	<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.8125 12C3.50473 12 0.8125 9.30777 0.8125 6C0.8125 2.68648 3.50473 0 6.8125 0C10.126 0 12.8125 2.68648 12.8125 6C12.8125 9.30777 10.126 12 6.8125 12ZM5.46063 8.95685C5.65047 9.14094 6.03589 9.12943 6.23724 8.9396L8.64759 6.67881C9.02727 6.32215 9.02727 5.69511 8.64759 5.33845L6.23724 3.07766C6.01288 2.87057 5.67923 2.86481 5.47214 3.0604C5.24203 3.27325 5.23628 3.63567 5.46063 3.84276L7.77319 6.00575L5.46063 8.1745C5.24203 8.38159 5.23053 8.72675 5.46063 8.95685Z" fill="white" />
	</svg>
</template>

<script>
export default {
	name: 'ArrowNextCircle',
};
</script>
